import React from 'react';

const StickyFooter = ({ children, className = '' }) => {
  return (
    <div
      className={`fixed bottom-0 left-0 right-0 bg-muted shadow-md z-30
      md:left-[var(--sidebar-width)] md:w-[calc(100%-var(--sidebar-width))]
      md:peer-data-[state=collapsed]:left-[calc(var(--sidebar-width-icon)+1rem)] md:peer-data-[state=collapsed]:w-[calc(100%-(var(--sidebar-width-icon)+1rem))]
      ${className}`}
    >
      {children}
    </div>
  );
};

export default StickyFooter;
